import { render, staticRenderFns } from "./SettingsPanes.vue?vue&type=template&id=06eec3a8&"
import script from "./SettingsPanes.vue?vue&type=script&lang=ts&"
export * from "./SettingsPanes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports